import React, { useState } from 'react';
import { getUserDetails } from '../Utility/AsyncStorage';
import * as FileSaver from 'file-saver';
import axios from "axios";
import { showToast } from '../Components/Toast';

function Report({ bodyData, onDownloadSuccess }) {
    var userdetails = getUserDetails()
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const today = new Date().toISOString().split('T')[0];

    console.log(bodyData)
    const downloadReport = async () => {
        if(fromDate.length == 0 || toDate.length == 0){
            showToast("Select date range for report download", 3000, "orange");
            return
        }
        try {

            let url = "https://itlapi.flovation.in/report/machineReport";
            let body = {
                comp_num: bodyData?.comp_num ?? undefined,
                device_id: bodyData?.device_id ?? undefined,
                machine_id: bodyData?.machine_id ?? undefined,
                from: fromDate,
                to: toDate,
                download: 1
            }
            console.log("report body", body)

            const response = await axios.post(url, body, {
                headers: {
                    'authorization': `${userdetails.access_token}`
                }, responseType: 'blob'
            })

            var blob = new Blob([response.data], {
                type: 'application/vnd.ms-excel',
            });
            let fileDate = new Date()
            var name = `ITL_Machine_Report_${bodyData.company_name}_${bodyData.device_id ? (bodyData.machine_id ? bodyData.machine_name : bodyData.device_name ): ""}_${fromDate}-${toDate} .xlsx`;
            FileSaver.saveAs(blob, name);
            onDownloadSuccess();
            showToast("Download Report successfully", 3000, "green");

        } catch (error) {
            console.log("companiesList", error)
        }
    }

    const handleFromChange = (e) => {
        setFromDate(e.target.value);
    };

    const handleToChange = (e) => {
        setToDate(e.target.value);
    };

    return (
        <div >

            <div className="flex items-center justify-between mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">From Date</label>
                <input
                    type="date"
                    value={fromDate}
                    max={today}
                    onChange={handleFromChange}
                    className="w-80 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
            </div>

            <div className="flex items-center justify-between mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">To Date</label>
                <input
                    type="date"
                    value={toDate}
                    min={fromDate}
                    max={today}
                    onChange={handleToChange}
                    className="w-80 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
            </div>

            <button
                onClick={downloadReport}
                className="bg-blue-500 hover:bg-blue-700 text-white px-4 py-2 rounded transition-colors duration-200 w-full"
            >
                <i className="fa fa-download text-[15px] px-2 "></i>
                Download Report
            </button>
        </div>
    );
}

export default Report;
